module.exports = __webpack_public_path__ + "img/ausstellung4.c071d705.jpg";